export default "__VITE_ASSET__BJTROMSt__"